import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export interface UpdateUserProfilePayload {
  userName: string;
  phoneNumber: string;
  azureToken: string;
  isRegisteredUser: boolean;
}

export interface UpdatedUserProfile {
  userName: string;
  email: string;
  phoneNumber: string;
}

export const updateUserProfileApi = async (
  token: string,
  payload: UpdateUserProfilePayload,
  t: (key: string) => string
): Promise<UpdatedUserProfile> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(`${baseUrl}/api/User/UpdateUserProfile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to update profile");
    }

    const data: UpdatedUserProfile = await response.json();
    return data;
  } catch (error) {
    // console.error("Error updating profile:", error);
    toast.error(t("updateProfile"));
    throw error;
  }
};
